var _rect, _rect2, _circle, _circle2, _circle3, _rect3, _text, _line, _circle4, _text2, _text3, _line2, _circle5, _text4, _text5, _line3, _rect4, _text6, _line4, _line5, _rect5, _text7, _rect6;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorBannerWebPreview(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 168,
    viewBox: "0 0 202 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 200.5,
    height: 166.5,
    fill: "#e9eaec",
    stroke: "#6A747F",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 200,
    height: 12,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 8,
    r: 2.5,
    stroke: "#9BA3AB",
    strokeWidth: 0.5,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 8,
    r: 2.5,
    stroke: "#9BA3AB",
    strokeWidth: 0.5,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 8,
    r: 2.5,
    stroke: "#9BA3AB",
    strokeWidth: 0.5,
    fill: "none"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 32,
    width: 181,
    height: 114,
    rx: 1,
    stroke: "#D9DBDE",
    strokeWidth: 0.5,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 48,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    letterSpacing: 0.3
  }, "SELECT YOUR PROTEIN")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 54,
    x2: 144,
    y2: 54,
    stroke: "#E9EAEC",
    strokeWidth: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 66,
    r: 3.5,
    stroke: "#9BA3AB",
    strokeWidth: 0.5,
    fill: "none"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 68,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    letterSpacing: 0.2
  }, "GRILLED CHICKEN")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 68,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F"
  }, "+$5.00")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 76,
    x2: 144,
    y2: 76,
    stroke: "#E9EAEC",
    strokeWidth: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 88,
    r: 3.5,
    stroke: "#9BA3AB",
    strokeWidth: 0.5,
    fill: "none"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 90,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    letterSpacing: 0.2
  }, "CRISPY CHICKEN")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 112,
    y: 90,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F"
  }, "+$5.00")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 98,
    x2: 144,
    y2: 98,
    stroke: "#E9EAEC",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 102,
    width: 120,
    height: 17,
    fill: "#6A747F"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 112,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "white"
  }, "Error banner")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 121,
    y1: 106,
    x2: 126,
    y2: 113,
    stroke: "white",
    strokeWidth: 0.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 126,
    y1: 106,
    x2: 121,
    y2: 113,
    stroke: "white",
    strokeWidth: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 122,
    width: 110,
    height: 15,
    rx: 1,
    stroke: "#d6dade",
    strokeWidth: 0.5,
    fill: "#d6dade"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 79,
    y: 131,
    fontFamily: "Arial, sans-serif",
    fontSize: 5,
    fill: "#6A747F",
    textAnchor: "middle",
    letterSpacing: 0.3
  }, "ADD TO CART")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 36,
    width: 42,
    height: 104,
    rx: 1,
    fill: "#E9EAEC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorBannerWebPreview);
export default __webpack_public_path__ + "static/media/error_banner_web_preview.1d1084e70d2055932d4010155d8b383e.svg";
export { ForwardRef as ReactComponent };